var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M 17.618983,3.3220339 12,8.941017 6.381017,3.3220339 3.3220339,6.381017 8.941017,12 3.3220339,17.618983 6.381017,20.677967 12,15.058983 17.618983,20.677967 20.677967,17.618983 15.058983,12 20.677967,6.381017 Z"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01cf4c58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/Error.vue
// module id = 5cSV
// module chunks = 0 1 3 4 5